import { useMemo } from 'react';
import { validateDesign } from '../../lib/designer/validate';

function ValidationPanel({ nodes, edges }) {
  const result = useMemo(() => validateDesign(nodes, edges), [nodes, edges]);

  if (result.errors.length === 0 && result.warnings.length === 0) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-2 p-4 text-center">
        <div className="rounded-full bg-teal-50 dark:bg-teal-900/30 p-3">
          <svg className="h-5 w-5 text-teal-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} aria-hidden="true">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <path d="M22 4L12 14.01l-3-3" />
          </svg>
        </div>
        <p className="text-sm font-medium text-gray-700 dark:text-gray-300">No issues found</p>
        <p className="text-xs text-gray-500 dark:text-gray-400">Design is valid and ready to export</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3 p-3 overflow-y-auto">
      {result.errors.length > 0 && (
        <div>
          <p className="text-xs font-semibold uppercase tracking-wider text-red-500 dark:text-red-400 mb-2">
            Errors ({result.errors.length})
          </p>
          <ul className="space-y-1.5">
            {result.errors.map((err, i) => (
              <li key={i} className="flex gap-2 text-xs text-red-600 dark:text-red-400">
                <span className="shrink-0">&#9888;</span>
                <span>{err}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {result.warnings.length > 0 && (
        <div>
          <p className="text-xs font-semibold uppercase tracking-wider text-amber-500 dark:text-amber-400 mb-2 mt-3">
            Warnings ({result.warnings.length})
          </p>
          <ul className="space-y-1.5">
            {result.warnings.map((warn, i) => (
              <li key={i} className="flex gap-2 text-xs text-amber-600 dark:text-amber-400">
                <span className="shrink-0">&#9888;</span>
                <span>{warn}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default ValidationPanel;
